// Models
import { AnyObjectType, PaginationPayload } from 'app/shared/models';
import { FullTagResponse } from 'app/modules/tags/responses';

export enum TeamActionTypes {
  RETRIEVE_API_CONFIGS = '@@team/RETRIEVE_API_CONFIGS',
  RETRIEVE_API_CONFIGS_SUCCESS = '@@team/RETRIEVE_API_CONFIGS_SUCCESS',

  RETRIEVE_ALL_TAGS = '@@team/RETRIEVE_ALL_TAGS',
  RETRIEVE_ALL_TAGS_SUCCESS = '@@team/RETRIEVE_ALL_TAGS_SUCCESS',

  ADD_TAG = '@@team/ADD_TAG',
  ADD_TAG_SUCCESS = '@@team/ADD_TAG_SUCCESS',
  CLEAR_ADDED_TAG = '@@team/CLEAR_ADDED_TAG',

  TAG_LIMIT_REACHED = '@@teams/TAG_LIMIT_REACHED',
  CLEAR_TAG_LIMIT_REACHED = '@@teams/CLEAR_TAG_LIMIT_REACHED',
}

export interface TeamState {
  tags: Record<number, FullTagResponse>;
  addedTags: Record<number, FullTagResponse>;
  api_config: ApiConfig;
  tagLimitReached?: boolean;
}

export interface ApiConfig {
  entity_page?: AnyObjectType;
  link_analysis?: Array<AnyObjectType>;
  allowed_endpoints?: string[];
  auto_assign_alerts?: boolean;
  agent_self_signup_allowed: boolean;
  self_signup_approval_required: boolean;
  allow_adding_agents: boolean;
}

export interface PaginatedTeamsPayload extends PaginationPayload {
  query?: string;
  ids?: number[];
}
